/**
 * Badge colorato per lo stato di un ordine di VENDITA.
 *
 * Separato da StatoOrdineBadge, che serve gli ordini di ACQUISTO e ha stati
 * diversi (confermato_fornitore, in_spedizione, in_ricezione): mettere insieme
 * due macchine a stati diverse in un componente solo le fa divergere.
 *
 * Usa solo classi Tailwind dal design system.
 */
import React from 'react';

interface Props {
  stato: string;
}

const STATI: Record<string, { label: string; className: string }> = {
  bozza: { label: 'Bozza', className: 'bg-muted text-muted-foreground' },
  confermato: { label: 'Confermato', className: 'bg-primary/10 text-primary' },
  fatturato: {
    label: 'Fatturato',
    className:
      'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  },
  annullato: { label: 'Annullato', className: 'bg-destructive/10 text-destructive' },
};

export function StatoOrdineVenditaBadge({ stato }: Props) {
  // Uno stato sconosciuto si mostra com'e' invece di sparire: se ne comparisse
  // uno nuovo, va visto, non nascosto.
  const config = STATI[stato] ?? {
    label: stato,
    className: 'bg-muted text-muted-foreground',
  };
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}

export default StatoOrdineVenditaBadge;
